import { useRef, useState } from 'react';
import { AiOutlineSend } from 'react-icons/ai';
import { RxCross1 } from 'react-icons/rx';
import { MessageType, showNotification } from '../../app_components/common/CommonStyle';
import { post } from '../../config/dataService/dataService';
import { useLocation } from 'react-router-dom';
import { Button, Form, Spin } from 'antd';
import { useDispatch } from 'react-redux';
import { addCommentData } from '../../redux/notesetting/notesSettingsSlice';
import TextArea from 'antd/lib/input/TextArea';

const ExternalNoteForm = ({
  onCancel,
  pendingNote,
  commentId,
  commentBlockId,
  imageData,
  workflowContactId,
  onDirtyChange,
  onCommentAdded,
}) => {
  const urls = {
    getcommenturl: 'PublicExternalProof/AddUpdateComments',
    getcommentBynoteid: 'PublicExternalProof/GetCommentById',
  };

  const location = useLocation();
  const stateData = location?.state || {};
  const imagedata = imageData || stateData.imageData;
  const workflowcontactId = workflowContactId || stateData.workflowContactId;

  const { coords } = pendingNote || {};
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [commentsDatafromNoteId, setCommentsDatafromNoteId] = useState([]);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const handleSubmit = async (values) => {
    setLoading(true);

    const datacomment = commentsDatafromNoteId[0] || {};
    const derivedCoords = {
      x: coords?.x?.size ?? datacomment.x,
      y: coords?.y?.size ?? datacomment.y,
    };

    const derivedImageData = {
      imageId: imagedata?.ImageId ?? datacomment.imageId,
      versionMappingImageId: imagedata?.VersionmapingImageId ?? datacomment.versionmapingImageId,
      proofId: imagedata?.ProofId ?? datacomment.proofId,
      versionId: imagedata?.VersionNo ?? datacomment.versionId,
    };

    try {
      const payload = {
        id: datacomment.id || commentBlockId || 0,
        commentId: commentId || 0,
        description: values.description,
        imageId: derivedImageData.imageId,
        versionmapingImageId: derivedImageData.versionMappingImageId,
        proofId: derivedImageData.proofId,
        isResolved: false,
        x: derivedCoords.x,
        y: derivedCoords.y,
        versionId: derivedImageData.versionId,
        proofWorkflowContactId: workflowcontactId,
      };

      const response = await post(urls.getcommenturl, payload);
      if (response.flag) {
        showNotification(MessageType.Success, 'Comment saved successfully');
        dispatch(addCommentData(response.data));
        form.resetFields();
        setIsDirty(false);
        onDirtyChange?.(false);
        onCommentAdded?.();
      } else {
        showNotification(MessageType.Error, response.message || 'Failed to save comment');
      }
    } catch (error) {
      showNotification(MessageType.Error, 'Failed to save comment');
    }
    setLoading(false);

  };

  const handleTextChange = (e) => {
    const value = e.target.value;
    const dirty = value.trim().length > 0;
    setIsDirty(dirty);
    onDirtyChange?.(dirty);
  };

  return (
    <div className="comment">
      <Spin spinning={loading}>

        <div className="custom-get-review-image-form">
          <Form onFinish={handleSubmit} form={form}>
            <Form.Item name="description" rules={[{ required: true, message: 'Please add a comment' }]}>
              <TextArea placeholder="Add a comment" autoSize ref={inputRef} onChange={handleTextChange} />
            </Form.Item>

            {onCancel && (
              <button className="cancel-button" type="button" onClick={onCancel}>
                <RxCross1 color="#fff" />
              </button>
            )}

            <Button
              htmlType="submit"
              type="primary"
              className="btn-enter ant-btn-reset"
              disabled={!isDirty}
            >
              <AiOutlineSend />
            </Button>          </Form>
        </div>
      </Spin></div>
  );
};

export default ExternalNoteForm;
